export default {"src":"/_next/static/media/plus_bracket.87acf71a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};